import {Component, OnInit} from '@angular/core';
import {LogServices} from '../../CoreModule/services/log.services';
import {NgxSpinnerService} from 'ngx-spinner';
import {LogModel, TIPOENTIDADES, TIPOLOG} from '../../CoreModule/models/log.model';
import * as moment from 'moment';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {TypeaheadMatch} from 'ngx-bootstrap';

@Component({
  selector: 'log-view',
  templateUrl: '../templates/log.template.html'
})
export class LogComponent implements OnInit {

  public tipo: string = TIPOLOG.PPTO;
  public fecha1: string = '';
  public fecha2: string = '';
  public entidad: TIPOENTIDADES = TIPOENTIDADES.TIENDA;
  public idEntidad: string = '';

  public lstTiendas:TiendaEntity[] = [];

  public lstEntidades:any[] = [];
  public lstTipos:any[] = [];
  public lstTiposEntidades:any[] = [];

  public lstLog: LogModel[] = [];



  constructor(private ls: LogServices, private spinner: NgxSpinnerService, private ts:TiendaServices) {
  }


  ngOnInit(): void {
    this.spinner.show();

    for(let tip in TIPOLOG){
      this.lstTipos.push(tip);
    }

    for(let te in TIPOENTIDADES){
      this.lstTiposEntidades.push(te);
    }

    this.ts.getAllTiendas().subscribe((d:any)=>{
      if(d.data.tiendas){
        this.lstTiendas = d.data.tiendas
      }

      this.cambiarEntidadesTienda();

      this.spinner.hide();
    })
  }

  cambiarEntidadesTienda(){
    this.lstEntidades = [];

    this.lstTiendas.map(t=>{
      this.lstEntidades.push({
        nombre: t.nombre,
        id: t.idDB
      })
    })
  }

  entidadSelect(event:TypeaheadMatch){
    this.idEntidad = event.item;
  }


  consultarLog() {
    this.spinner.show();
    this.lstLog = [];

    let filtros: any = {
      tipo: this.tipo,
      entidad: this.entidad
    };

    if (this.idEntidad != '')
      filtros.idEntidad = this.idEntidad;


    this.ls.getLog(filtros, this.fecha1, this.fecha2).subscribe((d: any) => {
      console.log(d);

      this.spinner.hide();

      if (d.data.getLog) {
        for (let l of d.data.getLog) {
          this.lstLog.push({
            tipo: l.tipo,
            fecha: moment(l.fecha).format('DD-MM-YYYY hh:mm:ss'),
            usuario: l.usuario,
            descripcion: l.descripcion,
            idEntidad: l.idEntidad,
            entidad: l.entidad
          });
        }
      }



    });

  }

}
